import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

import "../../css/createSourceModal.css";
import { getMondayURL, mondayStore } from "../../helpers/Sources/monday/monday";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const MondaySource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const language = useSelector((state) => state.languagesState.languages);

    const [mondayName, setMondayName] = useState("");
    const [mondayBtn, setMondayBtn] = useState(false);
    const [mondayCheck, setMondayCheck] = useState(false);
    const [mondayId, setMondayId] = useState("");

    const sendMondayData = async (data) => {
        let newData = {
            name: mondayName,
            code: data?.code,
            scope: data?.scope,
            usage_types: [4],
        };
        let response = await mondayStore(newData);
        if (response.status) {
            setMondayCheck(true);
            setMondayBtn(false);
            if (props.selectFileSourceId) {
                props.selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
            setMondayId(response?.data?.source?.id);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
    };

    const handleMondayName = (e) => {
        const inputValue = e.target.value;
        setMondayName(inputValue);
        setMondayBtn(true);
    };

    const saveCrmMapping = (response) => {
        if (props?.setLoading !== undefined) {
            props?.setLoading(true);
        }
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            setMondayBtn(false);
            setMondayName("");
            setMondayId("");
            setMondayCheck(false);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.getTracker) {
                props.addToTracker(mondayId);
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            props?.handleClose(mondayId);
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        }
    };

    return (
        <div>
            {mondayCheck ? (
                <>
                    <CrmSourceMappingArea
                        sourceId={mondayId}
                        sourceType={"monday"}
                        mappingSuccess={saveCrmMapping}
                        isModal={props?.isModal}
                        hideSaveButton={useHostFooter}
                        registerFooterAction={registerFooterAction}
                    ></CrmSourceMappingArea>
                </>
            ) : (
                <>
                    <FormControl className="mb-3" style={{ width: "100%" }}>
                        <TextField
                            name="mondayName"
                            label={language?.source_modal?.name ?? "Name"}
                            variant="outlined"
                            onChange={handleMondayName}
                            placeholder={
                                language?.source_modal?.please_write_name ??
                                "Please Write Name"
                            }
                            value={mondayName}
                        />
                    </FormControl>
                    <div className="position-relative overflow-hidden z-1">
                        {props?.isButtonLoader !== undefined &&
                            props?.isButtonLoader && (
                                <div className="circle-loader">
                                    <ClipLoader color={"#000"} size={17} />
                                </div>
                            )}
                        <LoginButton
                            getAuthUrl={getMondayURL}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.auth_url;
                            }}
                            code="monday"
                            paramNames={["code", "scope"]}
                            onSuccess={sendMondayData}
                            dataTransform={(params) => ({
                                code: params.code,
                                scope: params.scope,
                            })}
                            onLoadingChange={props?.setIsButtonLoader}
                            logoSrc="/assets/images/typeImages/monday.png"
                            buttonText={
                                language?.buttons?.connect_with_monday ??
                                "Connect with Monday"
                            }
                            disabled={!mondayBtn}
                            isLoadingExternal={props?.isButtonLoader}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default MondaySource;
